export default {
  intro: {
    default: 'Enter the details of the person who signs the contract.',
    gbr: 'Enter the details of the partner who signs the contract.',
    gmbh: 'Enter the details of the owner or managing director who signs the contract.',
  },
  sections: {
    home_address: 'Home address',
    home_address_help: "Where this person lives, not the restaurant's address.",
  },
  form: {
    owner_first_name: {
      label: 'First name',
      placeholder: 'Enter first name',
    },
    owner_last_name: {
      label: 'Last name',
      placeholder: 'Enter last name',
    },
    owner_dob: {
      label: 'Date of birth',
      placeholder: 'Date',
    },
    owner_phone_number: {
      label: 'Phone',
    },
    owner_email: {
      label: 'Email',
      placeholder: 'Enter email',
      help: 'This can be different from the email you log in with.',
    },
    owner_id_number: {
      label: 'ID number (e.g. Social security number in US)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Back',
    next: 'Next',
  },
};
